import styled from 'styled-components';
import { FormField } from 'ui/formField';
import { spacing } from 'ui/theme';

export const StyledFormField = styled(FormField)`
  &&& {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    width: 100%;
    margin: 0;

    & + & {
      margin-left: ${spacing.half};
    }

    > div:last-child {
      flex: 1 1 auto;
      width: 100%;
    }
  }
`;
